import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import InsightsServices from "../../services/Insights.services";
import TrackFeatureServices from "../../services/TrackFeature.services";
import { getTrackKeyInsights } from "../../utils/minified/MinifiedHelper";

function useGetMinifiedInsightsData() {
    const [isLoading, setIsLoading] = useState(true)
    const [simpleSummaryValue, setSimpleSummaryValue] = useState("")

    const { targets, visibleRecommendedInsightsModal: {
        data,
        visible
    } } = useSelector((state) => state.minified)

    useEffect(() => {
        if (visible) {
            setIsLoading(true)
            const { startMonitor, endMonitor } = TrackFeatureServices.getMonitor({ featureKey: getTrackKeyInsights(data.itemId) })
            let monitorUrl = ""
            const callBackGetUrl = (params, url) => {
                monitorUrl = url
                startMonitor(params, { url: monitorUrl })
            }
            InsightsServices.runSimpleSummary(targets, data.list, true, data.itemId, callBackGetUrl).then((resp) => {
                setSimpleSummaryValue(resp.data[0]);
                setIsLoading(false)
                endMonitor(resp, { url: monitorUrl })
                return resp
            })
        }
    }, [visible, data, targets])

    const getGenderData = (() => {
        const { gender_distribution = {} } = data?.genderAgeObj || {}
        return [{
            title: "Male",
            score: gender_distribution?.male || 0,
        }, {
            title: "Female",
            score: gender_distribution?.female || 0,
        }]
    })()
    const getAgeData = (() => {
        const { age_group_distribution = {} } = data?.genderAgeObj || {}
        return Object.keys(age_group_distribution).map((age) => ({
            title: age,
            score: age_group_distribution[age],
        }))
    })()

    const getColors = () => {
        const classType = data.classType.trim()
        if (classType === "green") {
            return ['#e0faef', '#a1efd0', '#63e5b1', '#24db92', '#1a9c69', '#105e3f', '#051f15']
        }
        if (classType === "blue") {
            return ['#e1e7f8', '#a5b7eb', '#6988de', '#2e58d1', '#213f96', '#14265a', '#070d1e']
        }
        return ['#fae6df', '#f1b4a0', '#e88360', '#df5120', '#9f3a17', '#5f230e', '#200c05']
    }

    return {
        isLoading,
        simpleSummaryValue,
        genderData: getGenderData,
        ageData: getAgeData,
        colors: getColors(),
        visible,
        data
    };
}

export default useGetMinifiedInsightsData;
